<template>
  <div>
    <!-- 自主集运授权设置 -->
    <el-dialog :title="$t('message.selfConsolidationAuthorizationSettings')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="888px" center>
      <div class="content">
        <!-- 自主集运授权 -->
        <div class="row">
          <el-checkbox v-model="is_co_authorized">{{ $t('message.selfConsolidationAuthorization') }}</el-checkbox>
        </div>
        <div class="row">
          <div class="label"> 请输入客户ID：</div>
          <div class="input"> <el-input v-model="searchText"></el-input> </div><el-button type="primary"
            @click="getAccountInfo">{{ $t('message.add')
            }}</el-button>
        </div>
        <div class="table">
          <ol>
            <li>No</li>
            <!-- 客户ID -->
            <li>{{ $t('message.clientID') }}</li>
            <!-- 客户名称 -->
            <li>{{ $t('message.userName') }}</li>
          </ol>
          <div class="ul">
            <ul v-for="(item, index) in list" :key="index">
              <li>{{ index + 1 }}</li>
              <!-- 客户ID -->
              <li>{{ item.auth_user_id }}</li>
              <!-- 客户名称 -->
              <li>{{ item.auth_realname }}</li>
            </ul>
          </div>

        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

export default {
  props: {
    detail: { type: Object },
  },
  data() {
    return {
      dialogVisible: false,
      is_co_authorized: false,
      searchText: "",
      list: []
    };
  },

  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        this.is_co_authorized = this.detail.is_co_authorized == 1 ? true : false
        this.searchText = ''
        this.getUserCoAuthUser()
      }
    }
  },
  methods: {
    // 查询授权给的客户列表
    getUserCoAuthUser() {
      this.$api.clienteleApi.getUserCoAuthUser({ user_id: this.$route.query.userID }).then(res => {
        this.list = res.data
      })
    },
    //  搜索
    getAccountInfo() {
      if (this.searchText == '') return false
      this.$api.clienteleApi.clientList({ id: this.searchText, pageSize: 50, page: 1 })
        .then((res) => {
          res.data.data.forEach(item => {
            item.auth_user_id = item.id
            item.auth_realname = item.realname
          })
          this.list = [... this.list, ...res.data.data]
          var hash = {};
          this.list = this.list.reduce(function (item, next) {
            hash[next.auth_user_id]
              ? ""
              : (hash[next.auth_user_id] = true && item.push(next));

            return item;
          }, []);
        });
    },
    // 保存
    save() {
      let datas = {
        user_id: this.$route.query.userID,
        is_co_authorized: this.is_co_authorized ? 1 : 0,
      };
      this.$api.clienteleApi.setUserCoAuth(datas).then((res) => {
        this.$message.success(res.msg);
        this.dialogVisible = false;
        this.$parent.clientDetail();
      });

      let data = {
        user_id: this.$route.query.userID,
        auth_user_id_set: []
      }
      this.list.forEach(item => {
        data.auth_user_id_set.push(item.auth_user_id)
      })
      this.$api.clienteleApi.setUserCoAuthUser(data)
    }

  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;
  padding: 24px;
  background: #f8f8f8;
  border-radius: 8px;



  .row {
    margin-bottom: 24px;
    display: flex;
    line-height: 40px;

    .input {

      margin: 0 12px;
    }
  }

  /deep/.el-radio__input {
    transform: scale(1.5) !important;
  }
}

.ul {
  max-height: 400px;
  overflow-y: auto;
}
</style>